"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliverableOverrideParam = void 0;
var DeliverableOverrideParam;
(function (DeliverableOverrideParam) {
    let deliverableType;
    (function (deliverableType) {
        deliverableType["PAY_PER_EVENT_BRACKET"] = "payPerEventBracket";
        deliverableType["PAY_PER_EVENT"] = "payPerEvent";
        deliverableType["CREATOR_PAY_PER_EVENT"] = "creatorPayPerEvent";
        deliverableType["LIVE_STREAM"] = "liveStream";
        deliverableType["YOU_TUBE_VIDEO"] = "youTubeVideo";
        deliverableType["TIK_TOK_CREATIVE"] = "tikTokCreative";
        deliverableType["CUSTOM"] = "custom";
        deliverableType["CONTRACT"] = "contract";
    })(deliverableType = DeliverableOverrideParam.deliverableType || (DeliverableOverrideParam.deliverableType = {}));
})(DeliverableOverrideParam = exports.DeliverableOverrideParam || (exports.DeliverableOverrideParam = {}));
